import React from 'react';
import {Grid, ColProps} from '@mantine/core';

export const EtroGridCol: React.FC<ColProps> = props => {
  return <Grid.Col {...props} />;
};
